module.exports = __webpack_public_path__ + "static/media/pedidos_logo.eb89aba4.svg";